<div class="rounded-md border border-neutral-400 px-4.5 py-5 text-neutral-800">
  <div class="flex items-center pb-5">
    <i class="icon icon-satisfied mr-3"></i>
    <span class="font-base font-bold lg:text-md">{{
      'basket.additonnal-informations.tip' | translate
    }}</span>
  </div>
  <div class="grid grid-cols-3 gap-1.5 sm:grid-cols-5 lg:grid-cols-6">
    <div>
      <app-button-square-atom
        class="text-sm"
        [text]="'tip-modal.none' | translate"
        [value]="0"
        [full]="true"
        [isActive]="!selectedTip"
        (buttonClick)="onSelectTip($event)"
      ></app-button-square-atom>
    </div>
    @if (choice1Amount && choice1Unit) {
      <div>
        <app-button-square-atom
          class="text-base"
          [value]="choice1Amount"
          [type]="$any(choice1Unit)"
          [secondaryAmount]="getChoiceSecondaryAmount(choice1Amount, choice1Unit)"
          [full]="true"
          (buttonClick)="onSelectTip($event)"
          [isActive]="isChoiceActive(choice1Amount, choice1Unit)"
        ></app-button-square-atom>
      </div>
    }
    @if (choice2Amount && choice2Unit) {
      <div>
        <app-button-square-atom
          class="text-base"
          [value]="choice2Amount"
          [type]="$any(choice2Unit)"
          [secondaryAmount]="getChoiceSecondaryAmount(choice2Amount, choice2Unit)"
          [full]="true"
          (buttonClick)="onSelectTip($event)"
          [isActive]="isChoiceActive(choice2Amount, choice2Unit)"
        ></app-button-square-atom>
      </div>
    }
    @if (choice3Amount && choice3Unit) {
      <div>
        <app-button-square-atom
          class="text-base"
          [value]="choice3Amount"
          [type]="$any(choice3Unit)"
          [secondaryAmount]="getChoiceSecondaryAmount(choice3Amount, choice3Unit)"
          [full]="true"
          (buttonClick)="onSelectTip($event)"
          [isActive]="isChoiceActive(choice3Amount, choice3Unit)"
        ></app-button-square-atom>
      </div>
    }
    <div>
      <app-button-square-atom
        class="text-sm"
        [text]="'tip-modal.other-amount' | translate"
        (click)="selectOtherTipAmount()"
        [isActive]="isOtherAmountSelected"
        [otherAmount]="otherAmount"
      ></app-button-square-atom>
    </div>
  </div>
</div>
